import styled from 'styled-components';

export const Container = styled.div`
	background: #fff;
	padding: 16px 16px;

	& .ant-breadcrumb > span:last-child {
		font-weight: 600 !important;
		opacity: 0.8;
	}

	& .ant-breadcrumb-link {
		font-size: 12px;
	}

	& > header {
		width: 100%;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		margin-bottom: 32px;

		& > h2 {
			color: rgba(0, 0, 0, 0.75) !important;
			display: flex;
			align-items: center;
			margin: 0;
			margin-bottom: -10px;
		}
	}
`;

export const ButtonsContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 12px;
`;

export const SelectOptContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 8px;

	& > strong {
		font-weight: 500;
		font-size: 15px;
	}

	& > small {
		font-size: 12px;
	}
`;
